import { useQuery } from "@apollo/client";

import type { GetGroupDockerImagesQuery } from "gql/graphql";
import { GET_GROUP_DOCKER_IMAGES } from "pages/group/scope/queries";
import { Logger } from "utils/logger";

const useDockerImagesQuery = (
  groupName: string,
): { dockerImagesData?: GetGroupDockerImagesQuery } => {
  const { data: dockerImagesData } = useQuery(GET_GROUP_DOCKER_IMAGES, {
    onError: ({ graphQLErrors }): void => {
      graphQLErrors.forEach((error): void => {
        Logger.error("Couldn't load group events", error);
      });
    },
    variables: { groupName },
  });

  return { dockerImagesData };
};

export { useDockerImagesQuery };
